"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _CheckboxBase = _interopRequireDefault(require("../../Field/CheckboxBase"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    "& + $root": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    }
  }
}));

const PrimusCheckListItemToggle = ({
  title,
  checked,
  onToggle
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Paper.default, {
    square: true,
    className: classes.root
  }, _react.default.createElement(_CheckboxBase.default, {
    label: title,
    checked: checked,
    onChange: onToggle
  }));
};

var _default = PrimusCheckListItemToggle;
exports.default = _default;
module.exports = exports.default;